module.exports = __webpack_public_path__ + "img/cabinet_color.945f5e99.svg";